// Direct chat URLs for agents (`/g/:id`). Used by Copy link / registry export.
// Catalog landing pages (`/agents/:slug`) are a separate SEO surface.

export const AGENT_SHARE_ORIGIN = 'https://gab.ai';

export function getAgentId(agentOrId) {
  if (!agentOrId) return '';
  if (typeof agentOrId === 'string') return agentOrId;
  return agentOrId.id || agentOrId._id || '';
}

export function getAgentChatUrl(agentOrId) {
  const id = getAgentId(agentOrId);
  if (!id) return '';
  if (typeof window !== 'undefined' && window.location?.origin) {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) {
      return `${window.location.origin}/g/${id}`;
    }
  }
  return `${AGENT_SHARE_ORIGIN}/g/${id}`;
}

export function isPrivateAgent(agentOrId) {
  if (!agentOrId || typeof agentOrId !== 'object') return false;
  return agentOrId.visibility === 'private';
}

export function formatAgentChatRegistry(agents) {
  return (Array.isArray(agents) ? agents : [])
    .filter((agent) => getAgentId(agent))
    .map((agent) => {
      const name = String(agent?.name || 'Agent').trim() || 'Agent';
      return `${name} — ${getAgentChatUrl(agent)}`;
    })
    .join('\n');
}
